import React, { useState } from 'react';
import { Maximize } from 'lucide-react';
import { InfoBox, InputGroup } from '../Common';

const CapTool = () => {
    const [rp, setRp] = useState(3);
    const [adr, setAdr] = useState(150);
    const res = (rp / (adr || 1)) * 100;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Range Capture Analyzer</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Required Profit" value={rp} onChange={setRp} />
                <InputGroup label="Avg Daily Range" value={adr} onChange={setAdr} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-blue">
                    <div className="tct-data-row"><span className="tct-label">Required Capture</span><span className="tct-value big-value val-amber">{res.toFixed(2)}%</span></div>
                </div>
            </div>
            <InfoBox
                title="Range Capture in Trading: How Much of the Market Move You Need"
                meta="Range capture measures the percentage of market movement a strategy captures"
                sections={[
                { title: "Introduction", content: "Traders often underestimate how small a portion of the market they need to capture." },
                { title: "Example", content: "Average daily range = 150 points<br>Strategy capture = 8 points<br><br>Range capture = 5%." }
                ]}
            />
        </div>
    );
};

export default CapTool;
